import React from 'react';
import PropTypes from 'prop-types';
import './styles.styl';

const Video = ({ videoFiles, onCompletion }) => {
  const onEnded = event => {
    onCompletion();
  };

  // TODO: if the user enables a <track> on one video,
  // store the kind and/or label in Redux and try to default to a matching <track> on future videos?

  const sources = videoFiles.sources.map((videoFile, index) => {
    return <source key={index} type="video/mp4" {...videoFile} />;
  });

  const tracks = videoFiles.tracks
    ? videoFiles.tracks.map((trackFile, index) => {
        return <track key={index} srcLang="en" {...trackFile} />;
      })
    : null;

  // media-has-caption will not detect that we do provide for (optional) <track> elements within the tracks variable
  /* eslint-disable jsx-a11y/media-has-caption */
  return (
    <video
      className="cep-video"
      controls
      controlsList="nodownload"
      preload="auto"
      onEnded={onEnded}
      poster={videoFiles.poster}
    >
      {sources}
      {tracks}
      Your browser does not support embedded video.
    </video>
  );
  /* eslint-enable jsx-a11y/media-has-caption */
};

Video.propTypes = {
  videoFiles: PropTypes.shape({
    sources: PropTypes.arrayOf(
      PropTypes.shape({
        src: PropTypes.string.isRequired,
        type: PropTypes.string
      })
    ).isRequired,
    tracks: PropTypes.arrayOf(
      PropTypes.shape({
        default: PropTypes.bool,
        kind: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        src: PropTypes.string.isRequired,
        srcLang: PropTypes.string
      })
    ).isRequired
  }).isRequired,
  onCompletion: PropTypes.func.isRequired
};

export default Video;



// WEBPACK FOOTER //
// ../core/src/components/Video/Video.js